// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4597252a","977":"7d4e9cf2"}[chunkId] + ".chunk.js";
};